/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Tomáš Burian (burian@cadwork.cz)
 *
 */

/**
 * @param {cadwork.webgl.SceneAPI.Scene} aSceneAPI
 * @extends cadwork.webgl.SceneAPI.elements.Element
 * @constructor
 */
import {DataStorage, EEmbededElementTypes, RenderDocument} from "js_renderer";
import Element from "./element";
import Factory from "./factory";
import {vec3} from "gl-matrix";
import Tube from "./tube";

export default
class Instrument extends Tube {

    public static TypeName: string = EEmbededElementTypes.INSTRUMENT;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);
    }

    public static create(aRenderDocument: RenderDocument): Instrument {
        let element = new Instrument(aRenderDocument);
        element._typeName = Instrument.TypeName;
        return element;
    }
}

Factory.register(Instrument);
